/** @jsx jsx */
import { InternationalComparisonChartWrapper } from '@charts';
import { ProtectedRouteAndRedirect } from 'src/components/composite/ProtectedRoute';
import { ChartContextWrapper } from 'src/components/composite/chart-generator/shared';
import { jsx } from 'theme-ui';

export default function () {
  return (
    <ChartContextWrapper>
      <ProtectedRouteAndRedirect path='/international-chart' component={InternationalComparisonChartWrapper} />
    </ChartContextWrapper>
  );
}
